export default __webpack_public_path__ + "static/media/promo-bg.66da5c36.png";